import React, { useState, useEffect } from 'react';
import FiltroRegistros from './FiltroRegistros';
import { useParams } from 'react-router-dom';
import { CallApiGet, CallApiPost } from '../../apicalls/calls';
import RegistroCaptura from './RegistroCaptura';
import Paginate from '../Parts/Paginate.jsx';
import AfterCaptura from './AfterCaptura';




export default function Registros(props) {
    const { id_sorteo } = useParams();
    const [Tabla, setTabla] = useState([]);
    const [Filtros, setFiltros] = useState({});
    const [Cantidad, setCantidad] = useState({});
    const UsuarioS = JSON.parse(window.localStorage.getItem('usuario'));

    //Paginacion
    const [currentItems, setCurrentItems] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);
    const itemsPerPage = 15;

    useEffect(() => {
        $("#backdrop").hide();
    }, [Tabla]);

    const Filter = async (values, actions) => {
        $("#backdrop").show();
        var params = { id_sorteo: id_sorteo, nombre: values.nombre, tipo: values.tipo, usuario: UsuarioS.user.id, usuario_tipo: UsuarioS.user.tipo_usuario };
        setFiltros(params);
        const Call = await CallApiGet('getRegistros', params, UsuarioS.access_token);
        if (Call.status != 200) {
            window.Swal.fire({
                icon: 'error',
                title: 'Error',
                text: Call.error.message,
            });
        } else {
            setTabla(Call.success.captura);
            //paginacion
            const endOffset = itemOffset + itemsPerPage;
            setCurrentItems(Call.success.captura.slice(itemOffset, endOffset));
            setPageCount(Math.ceil(Call.success.captura.length / itemsPerPage));
            //actions.resetForm();
        }
    }

    const OpenEdit = (item) => {
        setCantidad(item);
        $('#addSorteo').modal('show');
    }

    const Edit = async (values, actions) => {
        $("#backdrop").show();
        $('#addSorteo').modal('hide');
        var params = { id_sorteo: id_sorteo, id: values.id, tipo: 1, cantidad: values.cantidad };
        //setFiltros(params);
        const Call = await CallApiPost('accionesRegistros', params, UsuarioS.access_token);
        if (Call.status != 200) {
            window.Swal.fire({
                icon: 'error',
                title: 'Error',
                text: Call.error.message,
            });
        } else {
            const Call = await CallApiGet('getRegistros', Filtros, UsuarioS.access_token);
            if (Call.status != 200) {
                window.Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: Call.error.message,
                });
            } else {
                setTabla(Call.success.captura);
                const endOffset = itemOffset + itemsPerPage;
                setCurrentItems(Call.success.captura.slice(itemOffset, endOffset));
                setPageCount(Math.ceil(Call.success.captura.length / itemsPerPage));
                //actions.resetForm();
            }
        }
    }

    const Delete = (id) => {
        window.Swal.fire({
            title: `¿Está seguro de eliminar el registro?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar',
        }).then(async (result) => {
            if (result.isConfirmed) {
                var params = { id_sorteo: id_sorteo, id: id, tipo: 2 };
                const Call = await CallApiPost('accionesRegistros', params, UsuarioS.access_token);
                if (Call.status != 200) {
                    window.Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: Call.error.message,
                    });
                } else {
                    const Call = await CallApiGet('getRegistros', Filtros, UsuarioS.access_token);
                    if (Call.status != 200) {
                        window.Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: Call.error.message,
                        });
                    } else {
                        setTabla(Call.success.captura);
                        const endOffset = itemOffset + itemsPerPage;
                        setCurrentItems(Call.success.captura.slice(itemOffset, endOffset));
                        setPageCount(Math.ceil(Call.success.captura.length / itemsPerPage));

                        //actions.resetForm();
                    }
                }
            }

        });
    }

    //Paginacion

    useEffect(() => {
        // Fetch items from another resources.
        const endOffset = itemOffset + itemsPerPage;
        //console.log(`Loading items from ${itemOffset} to ${endOffset}`);
        setCurrentItems(Tabla.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(Tabla.length / itemsPerPage));
    }, [itemOffset, itemsPerPage]);

    // Invoke when user click to request another page.
    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % Tabla.length;
        setItemOffset(newOffset);
    };

    return (
        <div className='container-fluid'>
            {/*  <div className="d-sm-flex align-items-center justify-content-between mb-4">
                <h1 className="h3 mb-0 text-gray-800">Capturas del sorteo: </h1>
            </div> */}
            <div className="card shadow mb-4">
                <div className="card-header py-3">
                    <h6 className="m-0 font-weight-bold text-primary">Busqueda de registros</h6>
                </div>
                <div className='card-body'>
                    <FiltroRegistros Filter={Filter}>
                        <a style={{ marginLeft: '10px' }} type='submit' className='btn btn-primary btn-sm mt-30' onClick={() => $("#afterCaptura").modal('show')}>Nueva Captura</a>
                    </FiltroRegistros>
                    <div className='table-responsive'>
                        <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                            <thead>
                                <tr>
                                    <th>Coperativa</th>
                                    <th>Corredor</th>
                                    <th>Número</th>
                                    <th>Cantidad</th>
                                    <th>Tipo</th>
                                    <th>Fecha</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentItems.length == 0 && (
                                    <tr className='text-center'>
                                        <td colSpan={7}>No hay registros en la tabla</td>
                                    </tr>
                                )}
                                {currentItems && currentItems.map((item, key) => (
                                    <tr key={key}>
                                        <td>{item.coperativa}</td>
                                        <td>{item.corredor}</td>
                                        <td>{item.numero}</td>
                                        <td>{item.cantidad}</td>
                                        <td>{item.sorteo_tipo == 1 ? 'Primer lugar' : 'Segundo lugar'}</td>
                                        <td>{item.fecha_hora_captura!=null?window.moment(item.fecha_hora_captura).format('YYYY-MM-DD HH:mm:ss'):item.fecha_captura}</td>
                                        <td className="text-center">
                                            <a className="btn btn-danger btn-circle btn-sm" onClick={() => Delete(item.id)} data-bs-toggle="tooltip" data-bs-placement="top" title="Eliminar captura" ><i className="fa fa-times"></i></a>
                                            <a className="btn btn-success btn-circle btn-sm" onClick={() => OpenEdit(item)} data-bs-toggle="tooltip" data-bs-placement="top" title="Editar captura" ><i className="fa fa-file-signature"></i></a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className='float-md-right'>
                        <Paginate handlePageClick={handlePageClick} pageCount={pageCount} />
                    </div>
                </div>
            </div>
            <RegistroCaptura Edit={Edit} Cantidad={Cantidad} />
            <AfterCaptura />
        </div>
    )
}
